import { cast } from 'redpoints-front-common/helpers';

export const castOptions = {
  domainId: cast.number,
  filterByCustomer: cast.bool,
};
